import Axios from "axios";
import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
import { GET_PRICE_LISTS, GET_PRICE_LIST, SAVE_PRICE_LIST, DELETE_PRICE_LIST } from "../constants/action-types";
import { PriceListModel } from "../../pages/price-lists/models/PriceListModel";
import { PriceListItemModel } from "../../pages/price-lists/models/PriceListItemModel";

const API_CONFIG = getApiConfig();

/*
    Get all price lists that have been created.
*/
export const getPriceLists = (includePriceListItems = false, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/price-lists?includePriceListItems=${includePriceListItems}`, {
        method: "GET"
    }).then(res => {
        dispatch({
            type: GET_PRICE_LISTS,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
}

/*
    Get a particular price list.
*/
export const getPriceList = (includePriceListItems = false, priceListId, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/price-lists/${priceListId}?includePriceListItems=${includePriceListItems}`, {
        method: "GET"
    }).then(res => {
        var items = res.data;
        var priceListItems = [];
        var priceList = new PriceListModel();

        // Convert into expected price list payload...
        items.forEach((item) => {
            if (item.Type == "PriceList") {
                priceList = Object.assign(priceList, item);
            } else if (item.Type == "PriceListItem") {
                const priceListItem = new PriceListItemModel();
                priceListItems.push(Object.assign(priceListItem, item));
            }
        });
        
        priceList.PriceListItems = priceListItems;

        dispatch({
            type: GET_PRICE_LIST,
            payload: priceList
        });

        callback(priceList);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(null);
    })
}


/*
    Get a particular price list.
*/
export const savePriceList = (priceList, callback) => dispatch => {
    let submissionItems = createSubmissionItems(priceList);
    
    adalApiFetch(Axios, `${API_CONFIG.URL}/price-lists`, {
        method: "POST",
        data: submissionItems
    }).then(res => {
        dispatch({
            type: SAVE_PRICE_LIST,
            payload: priceList
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
}

/*
    Get a particular price list.
*/
export const updatePriceList = (priceList, callback) => dispatch => {
    let submissionItems = createSubmissionItems(priceList);

    adalApiFetch(Axios, `${API_CONFIG.URL}/price-lists`, {
        method: "PUT",
        data: submissionItems
    }).then(res => {
        dispatch({
            type: SAVE_PRICE_LIST,
            payload: priceList
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
}

function createSubmissionItems(priceList) {
    let mutablePriceList = Object.assign({}, priceList);
    
    // Create submission...
    var submissionItems = [];
    submissionItems = submissionItems.concat(mutablePriceList.PriceListItems);
    delete mutablePriceList.PriceListItems
    submissionItems.push(mutablePriceList);
    return submissionItems;
}

/*
    Get a particular price list.
*/
export const deletePriceList = (priceListIds, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/price-lists`, {
        method: "DELETE",
        data: priceListIds
    }).then(res => {
        dispatch({
            type: DELETE_PRICE_LIST,
            payload: priceListIds
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
}